import { useEffect } from "react";
import { useState } from "react";
import Get from "../api/Get";
import { ACCOUNT_GET } from "../api/Routes";
import { getTokenExternal } from "../utils/getTokenExternal";

export default function useGetNameAccount(idAccount){
    const [nameAccount, setNameAccount] = useState('')

    useEffect(() => {
        async function getAccountApi(){
            try {
                const respToken = await getTokenExternal()
                if(respToken.data.access_token){
                    const response = await Get({url: `${ACCOUNT_GET}/${idAccount}`, access_token: respToken.data.access_token})
                    if(response.data.state){
                        setNameAccount(response.data.data.name)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
        getAccountApi()
    }, [])

    return nameAccount
}